import Hero from "@/components/site/Hero";
import Pillars from "@/components/site/Pillars";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Pillars />
      <Process />
      <About />
      <FAQ />
      <Contact />
    </>
  );
}
